import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Translate plan names from English (source of truth) to Portuguese (display)
 * @param plan - The plan name in English (free, basic, pro, premium)
 * @returns The translated plan name in Portuguese
 */
export function translatePlanToPortuguese(plan: string): string {
  const translations: Record<string, string> = {
    'free': 'Gratuito',
    'basic': 'Básico',
    'pro': 'Pro',
    'premium': 'Premium'
  };
  return translations[plan.toLowerCase()] || plan;
}

/**
 * Translate plan names from Portuguese to English (for internal use)
 * @param plan - The plan name in Portuguese
 * @returns The plan name in English
 */
export function translatePlanToEnglish(plan: string): string {
  const translations: Record<string, string> = {
    'gratuito': 'free',
    'básico': 'basic',
    'pro': 'pro',
    'premium': 'premium'
  };
  return translations[plan.toLowerCase()] || plan.toLowerCase();
}
